import { Center, Spinner } from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import {
  useGetPortalSourcingEventQuery,
  useGetBidV2Query,
} from "../../../../autogen/bff-api";
import { useApiError } from "../../../../common/errors/useApiError";
import { PortalLayout } from "../components/PortalLayout";
import { EditBidV2Form } from "./EditBidV2Form";
import { BidV2ReadonlyView } from "./readonly/BidV2ReadonlyView";
import { showsReadonlyBid } from "./readonly/readonlyBidStatus";

export const EditBidV2Page = () => {
  const { eventId, bidId } = useParams<{ eventId: string; bidId: string }>();
  const displayer = useApiError();

  const bidQuery = useGetBidV2Query({ bidId: bidId ?? "" }, { skip: !bidId });
  const eventQuery = useGetPortalSourcingEventQuery({ eventId: eventId ?? "" }, { skip: !eventId });

  if (bidQuery.error) return displayer.show(bidQuery.error);
  if (eventQuery.error) return displayer.show(eventQuery.error);

  if (!eventId || !bidId || !bidQuery.data || !eventQuery.data) {
    return (
      <PortalLayout>
        <Center py="24">
          <Spinner color="smPrimary" />
        </Center>
      </PortalLayout>
    );
  }

  if (showsReadonlyBid(bidQuery.data)) {
    return (
      <BidV2ReadonlyView eventId={eventId} bidId={bidId} bid={bidQuery.data} event={eventQuery.data} />
    );
  }

  return (
    <EditBidV2Form eventId={eventId} bidId={bidId} bid={bidQuery.data} event={eventQuery.data} />
  );
};
